export const fetchStudentProfile = async ({ BeURL , showAlert}) => {
    try{
        if(!BeURL) {
            alert("Backend URL not provided")
            return false;
        }

        const res = await fetch(`${BeURL}/fetch-student-profile`, { credentials: "include" });

        const data = await res.json();
        
        if(data.success) return data;
        else {
            alert(data.message);
            return false;
        }
    }
    catch(err){
        alert("Trouble in connecting to the server. Please try again later.")
        console.log("Error in fetching user info:",err);
        return null;
    }
}